import Parse from 'html-react-parser';

function BMP20137(props) {
    let svgCode =
    `<svg width="56" height="120" viewBox="0 0 56 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="60" width="56" height="60" fill="${props.darkFill}"/>
        <path d="M33 81V88H23V80.5M29 85V81M21 101V93.5L22.5 92H33.5L35 93.5V101M36 80L17 80L17 102L39 102L39 84L36 80Z" stroke="${props.highlightColour}" stroke-width="2"/>
        <path d="M33 21V28H23V20.5M29 25V21M21 41V33.5L22.5 32H33.5L35 33.5V41M36 20L17 20L17 42L39 42L39 24L36 20Z" stroke="${props.highlightColour}" stroke-width="2"/>
    </svg>`

    props.svgReturn(61, svgCode, "bmp00137", 56, 120);

    const style = {
        position: "absolute",
        overflow: "hidden",
        height: "60px",
        top: "2px",
        left: "852px",
        display: props.display
    }

    const inStyle = {
        marginTop: "0px"
    }

    return (
        <div style={style}>
            <div style={inStyle}>
            {Parse(svgCode)}
            </div>
        </div>
    );
}

export default BMP20137;